import React from 'react';
import RedirectCard from '~/components/RedirectCard';

export default function LoginRedirectPage() {
    return <RedirectCard title="Login Required" message="We are redirecting you to the login page..." />;
}
